module.exports = __webpack_public_path__ + "img/Character_Layla_Thumb.f22e7d99.png";